module.exports = __webpack_public_path__ + "static/img/drilling2.42e84316.png";